import React from "react";
import { Checkbox as MuiCheckbox, FormControlLabel } from "@mui/material";

const Checkbox = ({ label, disabled, formSx, ...rest }) => {
  return (
    <FormControlLabel
      disabled={disabled}
      sx={{
        ".MuiFormControlLabel-label": {
          color: "secondary.main",
          fontFamily: "Montserrat",
          fontWeight: "600",
        },
        ...formSx,
      }}
      control={
        <MuiCheckbox
          sx={{
            fontSize: "2rem",
            mt: "-0.5rem",
            "&.Mui-checked": {
              color: "secondary.main",
            },
          }}
          {...rest}
        />
      }
      label={label}
    />
  );
};

export default React.memo(Checkbox);
